import React, { useEffect, useState } from "react";
import { teamApi, getImageUrl } from "../api";
import ImageLoader from "./common/ImageLoader";
import "./AdminTeam.css";

const AdminTeam = () => {
  const [members, setMembers] = useState([]);
  const [formData, setFormData] = useState({ name: "", title: "", image: null });
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await teamApi.getAll();
      setMembers(res.data || []);
    } catch (err) {
      console.error("❌ Error fetching members:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, image: file }));
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.image || !formData.name || !formData.title)
      return alert("Please fill all fields.");

    setLoading(true);
    const data = new FormData();
    data.append("name", formData.name);
    data.append("title", formData.title);
    data.append("image", formData.image);

    try {
      await teamApi.create(data);
      alert("✅ Team member added!");
      setFormData({ name: "", title: "", image: null });
      setPreviewUrl(null);
      e.target.reset();
      fetchMembers();
    } catch (err) {
      console.error("Upload error:", err);
      alert("❌ Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this team member?")) return;
    try {
      await teamApi.delete(id);
      alert("🗑️ Deleted successfully!");
      fetchMembers();
    } catch (err) {
      console.error("❌ Delete failed:", err);
    }
  };

  return (
    <div className="admin-team-wrapper">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-user-friends title-icon"></i>
          <div>
            <h2>Core Team Members</h2>
            <p className="panel-subtitle">Manage executive leadership and key organizers</p>
          </div>
        </div>
      </div>

      <div className="team-container-grid">
        {/* Form Card */}
        <div className="team-form-box">
          <h3 className="sub-heading-tag"><i className="fas fa-user-plus"></i> Add Team Member</h3>
          <form onSubmit={handleSubmit} className="admin-glass-form">
            <div className="admin-form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="name"
                placeholder="e.g. John Doe"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label>Role / Position Title *</label>
              <input
                type="text"
                name="title"
                placeholder="e.g. Lead Organizer"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label><i className="fas fa-camera"></i> Member Photo *</label>
              <input type="file" accept="image/*" onChange={handleImageChange} required />
              {previewUrl && (
                <div className="team-avatar-preview">
                  <img src={previewUrl} alt="Preview" />
                </div>
              )}
            </div>

            <button type="submit" className="admin-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin"></i> Adding...
                </>
              ) : (
                <>
                  <i className="fas fa-check"></i> Save Member
                </>
              )}
            </button>
          </form>
        </div>

        {/* Member Grid */}
        <div className="team-members-list-box">
          <h3 className="sub-heading-tag">
            <i className="fas fa-id-badge"></i> Current Members ({members.length})
          </h3>

          {members.length === 0 ? (
            <p className="no-items-text">No team members found.</p>
          ) : (
            <div className="admin-team-grid">
              {members.map((m) => (
                <div className="admin-team-card" key={m.id}>
                  <div className="admin-avatar-frame">
                    <ImageLoader src={getImageUrl(m.imagePath || m.image)} alt={m.name} />
                  </div>
                  <div className="admin-team-meta">
                    <h4>{m.name}</h4>
                    <span className="admin-team-title-tag">{m.title}</span>
                  </div>
                  <button
                    className="delete-team-member-btn"
                    onClick={() => handleDelete(m.id)}
                    title="Delete member"
                  >
                    <i className="fas fa-trash-alt"></i> Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminTeam;
